import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "./ModernTheme.css";
import { saveAs } from "file-saver";
import { CardContext } from "../../store/CardContext";
import { BsQrCodeScan } from "react-icons/bs";
import ftLogo from "../../../assests/img/footer_logo.svg";
import share from "../../../assests/img/share_icon.svg";
import linkedin from "../../../assests/img/linkedIn_white.svg";
import insta from "../../../assests/img/insta_white.svg";
import fb from "../../../assests/img/fb_white.svg";
import twitter from "../../../assests/img/tw_white.svg";
import whatsapp from "../../../assests/img/Whatsapp_white.svg";
import { IoIosArrowForward } from "react-icons/io";
import addtoHome from "../../../assests/img1/addtoHome.jpg";
import tiktok from "../../../assests/img1/tiktok-white.svg";
import skype from "../../../assests/img1/skype-white.svg";
import youtube from "../../../assests/img1/youtube-white.svg";
import snapchat from "../../../assests/img1/snapchat-white.svg";
import Filesimg from "../../../assests/img/files-img.svg";
// import leftarrow from "../../../assests/img1/left_arrow.svg";
// import arrow from "../../../assests/img/more_icon.svg";
import companypfImage from "../../../assests/img1/companyProfile_wht.svg";
import SlideSocialMediaStd from "../Common/socialMedia/SlideSocialMediaStd";
import SlideSocialMediaStandard from "../Common/socialMedia/SlideSocialMediaStandard";
import { SocialMediaValid } from "../Common/DivValidation";
import Footer from "../Common/footer/Footer";
import { FaExchangeAlt } from "react-icons/fa";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import QRModal from "../Common/qrModals/QRModal";
import { FaUser } from "react-icons/fa";
import { TbArrowsExchange } from "react-icons/tb";
import phn from "../../../assests/img/phoneicon.svg";
import mail from "../../../assests/img/emailicon.svg";
import loc from "../../../assests/img/loactionicon.svg";
// import { BsQrCodeScan } from "react-icons/bs";
import shareIcon from "../../../assests/img1/share_icon_w.svg";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoCloseOutline, IoLink } from "react-icons/io5";
import addIcon from "../../../assests/img1/addContact.svg";
import { RiDirectionLine } from "react-icons/ri";
import { BsCursor, BsPlus, BsUpload, BsWhatsapp } from "react-icons/bs";
import moreIcon from "../../../assests/img/more_icon.svg";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";
import ContactCardStd from "../Common/contactCards/ContactCardStd";
import WebsiteStd from "../Common/websiteCards/WebsiteStd";
import DownloadCardStd from "../Common/fileDownloadsCards/DownloadCardStd";
import ReviewCardStd from "../Common/reviewCards/ReviewCardStd";
const defaultBackgroundImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultBackground.jpg";
const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";

function ModernTheme({ card, preview,iconColor, color }) {
  const Textcolor = card?.textColor ? card?.textColor : "#000000";
  const Highlightcolor = card?.colorCode ? card?.colorCode : "linear-gradient(90deg, #FF5030 0%, #DD2475 100%)";

  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#F8F8F8";
  const BgColor = card?.bgColor ? card?.bgColor : "#FFFFFF";

  const BtIColor = card?.btIconColor ? card?.btIconColor : "#FFFFFFF";

  const [qrModal, setQrModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [cardData] = useContext(CardContext);
  const {

    backgroundImage,
    website,
    review,
    fileName,
    files,
    checkPfCard,
    footerText
  } = cardData

  const headlines = card?.headlines

  const shareMail2 = (e) => {
    window.location = `mailto:${card?.secondaryEmail}`;
    e.preventDefault();
  };

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };
  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "check it out",
          url: window.location.href,
          title: card.name,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(true);
  const handleClose = (e) => {
    setQrModal(false);
    setShowResults(false);
  };

  const handleDownload = () => {
    let url = card?.QRCode;
    saveAs(url, card?.name);
  };
  const SocialMediaImageCheck = SocialMediaValid();

  

  const shareMail = (e) => {
    window.location = `mailto:${card?.email}`;
    e.preventDefault();
  };

  const slideLeft = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft - 100;
  };
  const slideRight = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft + 100;
  };

  const array = card?.name ? card?.name?.split(" ") : "";



  const exchangeButton = (
    <button
      // onClick={preview ? handleShare : null}
      className="flex items-center justify-center py-2 px-2 text-[12px] h-full flex-1 bg-transparent rounded-r-full"
      style={{
        border: `1px solid ${Highlightcolor || "black"}`,

        color: Highlightcolor || "",
      }}
    >
      <TbArrowsExchange className="w-4 h-4 mr-2" />
      {/* Exchange Contacts */}
      {card?.exchangeContact?.buttonName}
    </button>
  );

  const directionButton = (
    <button
      // onClick={onClick}
      className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
      style={{
        backgroundColor: Highlightcolor || "black",
        color: isDarkColor(Highlightcolor) ? "white" : "black",
      }}
    >
      <RiDirectionLine
        className="mr-2"
        size={18}
        style={{  color: isDarkColor(Highlightcolor) ? "white" : "black", }}
      />
      <span className="font-medium text-[12px]" style={{   color: isDarkColor(Highlightcolor) ? "white" : "black",}}>
        Directions
      </span>
    </button>
  )

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();
  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }
  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };
  const imageStyle = {
    backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
    backgroundPosition: "center 300px",
    backgroundImage: `url(${card?.bgImg})`,
    backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  };
  const colorStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundColor: BgColor,
  };
  const defaultStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundImage: 'white'
  };
  return (
    <div>
      <section className="previewWrapModern " style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}>
        {preview ? (
          <div className="fixed bottom-0 right-7 z-10 space-y-4">
            {!isOpen && (
              <div className="relative group">
                <div className="flex items-center space-x-2">
                  <span
                    className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                    style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                  >
                    Share
                  </span>
                  <button
                    onClick={toggleButtons}
                    className="border rounded-full p-2 bg-blue-500 hover:bg-blue-600 transition-transform duration-[1s] ease-in-out"
                    style={{
                      backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                      borderColor: `${Highlightcolor ? Highlightcolor : ""}`
                    }}
                  >
                    <IoShareSocialOutline size={23} color={iconColor} />
                  </button>
                </div>
              </div>
            )}

            {isOpen && (
              <>
                {/* Profile Link Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.1s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-24 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      Profile Link
                    </span>
                    <button
                      onClick={handleShare}
                      className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}

                    >
                      <IoLink size={23} />
                    </button>
                  </div>
                </div>

                {/* QR Code Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.2s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-16 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      QR Code
                    </span>
                    <button
                      onClick={() => setQrModal(true)}
                      className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out" style={{ borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      <BsQrCodeScan size={23} style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }} />
                    </button>
                  </div>
                </div>

                {/* Close Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.3s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      Close
                    </span>
                    <button
                      onClick={toggleButtons}
                      className="border rounded-full p-2 text-white cursor-pointer transition-transform duration-[1s] ease-in-out"
                      style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      <IoCloseOutline size={23} color={iconColor} />
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          // <div className="flex justify-center gap-[20px] fixed top-[90%] lg:left-[45%] left-[35%]   ">
          //   <button
          //     className="w-[50px] h-[50px] flex justify-center p-[15px] rounded-[12px] shadow bg-white"
          //     onClick={handleShare}
          //   >
          //     <svg
          //       width="24"
          //       height="24"
          //       viewBox="0 0 24 24"
          //       fill="none"
          //       xmlns="http://www.w3.org/2000/svg"
          //     >
          //       <path
          //         d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22Z"
          //         fill="black"
          //       />
          //     </svg>
          //   </button>
          //   <button
          //     className="w-[50px] h-[50px] flex justify-center shadow p-[10px] rounded-[12px] bg-white"
          //     onClick={() => setQrModal(true)}
          //   >
          //     <svg
          //       width="34"
          //       height="34"
          //       viewBox="0 0 34 34"
          //       fill="none"
          //       xmlns="http://www.w3.org/2000/svg"
          //     >
          //       <path
          //         d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
          //         fill={Highlightcolor ? Highlightcolor : "black"}
          //       />
          //     </svg>
          //   </button>

          //   {card?.exchangeContact?.show ?
          //     <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
          //     : ""
          //   }

          // </div>
        ) : (
          ""
        )}


        <div className="bannerImage">
          {card?.profileImage ? (
            card?.checkProfile ? (
              <img src={card?.profileImage} alt="" />
            ) : (
              <img src={defaultProfileImage} alt="" />
            )
          ) : (
            <img src={defaultProfileImage} alt="" />
          )}
          <div
            className="overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the color and opacity here
              pointerEvents: "none", // Ensure the overlay doesn't interfere with interactions
            }}
          />
        </div>

        {/* <div className="btnrelativeModern"> */}

        <div className="previewContainerModern">
          <div className="header">
            {/* <img src={logo} alt="logo zeeqr" />
                          <Link className="btn" to={"hhttps://zeeqr.com/"} target="_blank">Get your card</Link>  */}
          </div>
          <div className="logo" />
          {card?.checkPfCard ? (
            <div
              className="userDetails"
              style={{
                background: Highlightcolor ? Highlightcolor : "black", // Fallback to black if Highlightcolor is falsy
                color: isDarkColor(Highlightcolor) ? "white" : "black", // Text color based on Highlightcolor
              }}
            >
              <div
                className="text"
                style={{
                  width: `${!card?.checkLogo ? "max-content" : ""}`,
                  padding: `${!card?.checkLogo ? "10px 0 10px 20px" : " 0 0 0 20px"
                    }`,
                    color: isDarkColor(Highlightcolor) ? "white" : "black",
                  fontWeight: "bold",
                  paddingLeft: "20px",
                  fontSize: `${array[0]?.length > 12 ||
                    array[1]?.length > 12 ||
                    array[2]?.length > 12
                    ? "20px"
                    : "25px"
                    }`,
                }}
              >
                {card?.name}
                <div
                  className="text"
                  style={{ fontSize: "15px", fontWeight: "bold",  color: isDarkColor(Highlightcolor) ? "white" : "black", }}
                >
                  {card?.companyDesignation}
                </div>
              </div>


              {/*  --------------------------------- logo --------------------------------  */}

              {card?.checkLogo ? (
                <div className="companyLogo">
                  {card?.companyLogo ? (
                    <img className="object-contain" src={card?.companyLogo} alt="" />
                  ) : (
                    <img src={defaultBackgroundImage} alt="" />
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}


          {/*  --------------------------------- add to contact , exchange contact  --------------------------------  */}

          <div
            className={`buttons w-full ${preview ? "bottom-0 mb-6" : "mb-0"}`}
          >
            <div className="flex w-full h-full rounded-full p-[2px]">
              <Link
                 onClick={() => handleTap('saveContact')}
                 className="addTo flex items-center justify-center gap-1 bg-black text-white py-2 px-2 rounded-l-full text-[10px] font-medium"
                 to={`${preview ? card?.vCard : ""}`}
                 style={{
                   backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                     }`,
                 
                       color: isDarkColor(Highlightcolor) ? "white" : "black",
                  
                 }}
               >
     <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M7.5 8C9.29493 8 10.75 6.54493 10.75 4.75C10.75 2.95507 9.29493 1.5 7.5 1.5C5.70507 1.5 4.25 2.95507 4.25 4.75C4.25 6.54493 5.70507 8 7.5 8Z"        stroke={isDarkColor(Highlightcolor) ? "white" : "black"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
 <path d="M13.68 14.5C13.2602 13.1908 12.4355 12.0488 11.3248 11.2386C10.2141 10.4284 8.8748 9.99182 7.5 9.99182C6.1252 9.99182 4.78591 10.4284 3.67522 11.2386C2.56453 12.0488 1.73982 13.1908 1.32 14.5H13.68Z" stroke={isDarkColor(Highlightcolor) ? "white" : "black"}  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
 </svg>
 
                 Add to contacts
              </Link>

              {card?.exchangeContact?.show ? (
                <ExchangeContact
                  customButton={exchangeButton}
                  details={card?.exchangeContact}
                  cardId={card._id}
                />
              ) : null}
            </div>
          </div>
          {/*  --------------------------------- about --------------------------------  */}


          {card?.about ? (
            <div>
              <div className="flex items-center gap-2">
                <p className="font-semibold   text-[16px]" style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}>
                  {/* About {card?.aboutHeadline ? card?.aboutHeadline : ""} */}
                  {headlines?.aboutHeadline ? headlines?.aboutHeadline : 'About'}
                </p>
                <p
                  style={{
                    borderBottom: `3px  solid ${Highlightcolor }
                      }`,
                    height: "4px",
                  }}
                >
                  &nbsp; &nbsp; &nbsp;{" "}
                </p>
              </div>
              <div className="about whitespace-pre-line" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>{card?.about}</div>
            </div>
          ) : (
            ""
          )}

          {/* -----------------------------------------social media------------------------------------------ */}


          {SocialMediaImageCheck ||
            (card?.socialMedias && card?.socialMedias?.length !== 0) ? (
            <>
              <div className="flex mb-3 items-center gap-2">
                <p className="font-semibold  text-[16px]" style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}>
                  {/* Social media links */}
                  {headlines?.socialMediaHeadline ? headlines?.socialMediaHeadline : 'Social Media'}
                </p>
                <p
                  style={{
                    borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                      }`,
                    height: "4px",
                  }}
                >
                  &nbsp; &nbsp; &nbsp;{" "}
                </p>
              </div>
              {/* <SlideSocialMediaStd preview={preview} color={'white'} Highlightcolor={Highlightcolor} /> */}
              {card?.socialMedias && card?.socialMedias?.length !== 0 ? (
                <SlideSocialMediaStandard
                  preview={preview}
                  iconColor=  {iconColor = color ? color : '#000000'}  Highlightcolor={Highlightcolor} Iconcolor={Iconcolor}
                  theme={"modern"}
                />
              ) : (
                <SlideSocialMediaStd
                  preview={preview}
                  iconColor=  {iconColor = color ? color : '#000000'} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor}
                  theme={"modern"}
                />
              )}
            </>
          ) : (
            ""
          )}
          {/* --------------------------------------------------contact details----------------------------------------------------------------------------- */}

          <div
            className={`flex mb-2 items-center gap-2 ${!card?.checkPfCard && !card?.about && !card?.SMediaPostion?.pos1
              ? "mt-20"
              : "mt-10"
              }`}
          >
            <p className="font-semibold  text-[16px]" style={{
              color: `${Textcolor ? Textcolor : ""}`,
            }}>
              {/* Contact Info */}
              {headlines?.contactHeadline ? headlines?.contactHeadline : 'Contact info'}
            </p>
            <p
              style={{
                borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                  }`,
                height: "4px",
              }}
            >
              &nbsp; &nbsp; &nbsp;{" "}
            </p>
          </div>

          <ContactCardStd preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} customButton={directionButton} />

          {/*  --------------------------------- old website with image--------------------------------  */}

          {/* {card?.websiteImage || card?.websiteName || card?.websiteUrl ? (
            <div>
              <div className="flex mt-5 gap-3 justify-start items-center">
                <p className="font-bold text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>Website</p>
                <p
                  style={{
                    borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                      }`,
                    height: "4px",

                  }}
                >
                  &nbsp; &nbsp; &nbsp;{" "}
                </p>
              </div>
              <div className="otherLinks mt-2 rounded-[8px]">
                <Link
                  to={`${preview ? card?.websiteUrl : ""}`}
                  target={`${preview ? "_blank" : ""}`}
                  className="flex items-center realtive justify-between border-2 border-[#F7F7F7] bg-transparent  rounded-[8px] overflow-hidden"
                >
                  <svg width="13" className="absolute right-7  transform -translate-y-1/2 " height="13" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L1 9" stroke={BtIColor || "#888888"} stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <figure className="min-w-[80px] w-[80px] h-[89px]">
                    <img
                      src={card?.websiteImage || defaultBackgroundImage}
                      alt=""
                      className="w-full h-full object-cover rounded-l-[8px]"
                    />
                  </figure>
                  <figcaption className="text-[14px] font-semibold text-white " style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                    {card?.websiteName}
                  </figcaption>
                </Link>

              </div>
            </div>
          ) : (
            ""
          )} */}

          {/*  --------------------------------- website --------------------------------  */}

          {(card?.website ? card?.website[0]?.websiteName : '') ? (
            <div >


              <div className="flex  mb-3 items-center gap-2">
                <p className="font-semibold text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {/* Website */}
                  {headlines?.websiteHeadline ? headlines?.websiteHeadline : 'Website'}
                </p>
                <p
                  style={{
                    borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                      }`,
                    height: "4px",

                  }}
                >
                  &nbsp; &nbsp; &nbsp;{" "}
                </p>
              </div>


              <WebsiteStd website={card?.website} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />

            </div>
          ) : (
            ""
          )}



          {/*  --------------------------------- files --------------------------------  */}


          {fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ? (
            <div>
              <div className="flex  mb-3 items-center gap-2">
                <p className="font-semibold  text-[16px]" style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}>
                  {/* Attachments */}
                  {headlines?.filesHeadline ? headlines?.filesHeadline : 'Attachments'}
                </p>
                <p
                  style={{
                    borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                      }`,
                    height: "4px",
                  }}
                >
                  &nbsp; &nbsp; &nbsp;{" "}
                </p>
              </div>
              <DownloadCardStd
                preview={preview}
                fileName={fileName}
                files={files}
                BtIColor={BtIColor}
                Textcolor={Textcolor}
                Iconcolor={Iconcolor}
              />
            </div>
          ) : (
            ""
          )}


          {/*  --------------------------------- review --------------------------------  */}

          {card?.reviews ? (
            card?.reviews[0]?.reviewName ? (
              <div
                className="contactOptions3"
              // style={{
              //   color: `${Textcolor ? Textcolor : ""}`,
              //   backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
              // }}
              >
                {/* <h4>Review</h4> */}
                <div className="flex mb-3 items-center gap-2">
                  <p className="font-semibold  text-[16px]" style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}>
                    {/* Review */}
                    {headlines?.reviewHeadline ? headlines?.reviewHeadline : 'Review'}
                  </p>
                  <p
                    style={{
                      borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                        }`,
                      height: "4px",
                      // marginTop: "18px",
                    }}
                  >
                    &nbsp; &nbsp; &nbsp;{" "}
                  </p>
                </div>
                <ReviewCardStd reviews={card?.reviews} preview={preview} Textcolor={Textcolor} BtIColor={BtIColor} />
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}


          {/*  --------------------------------- gallery --------------------------------  */}

          {card?.highlightPhotos[0].highlightPhotos1 ||
            card?.highlightPhotos[0].highlightPhotos2 ||
            card?.highlightPhotos[0].highlightPhotos3 ||
            card?.highlightPhotos[0].highlightPhotos4 ||
            card?.highlightPhotos[0].highlightPhotos5 ||
            card?.highlightPhotos[0].highlightPhotos6 ||
            card?.highlightPhotos[0].highlightPhotos7 ||
            card?.highlightPhotos[0].highlightPhotos8 ? (
            card?.checkHighlight ? (
              <div>
                <div className="flex mb-3 items-center gap-3">
                  <p className="font-semibold  text-[16px]" style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}>Gallery</p>
                  <p
                    style={{
                      borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "#e71545"
                        }`,
                      height: "4px",
                      // marginTop: "18px",
                    }}
                  >
                    &nbsp; &nbsp; &nbsp;{" "}
                  </p>
                </div>
                <HighlightImage />
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {/*  --------------------------------- footer ---------------------------------  */}
        </div>
        {card?.footerText && <Footer />}

        {/* <div className="footer flex flex-col items-center">
          {preview ? (
            <>
              <p>
                Powered by{" "}
                <Link to={"hhttps://zeeqr.com/"} target="_blank">
                  ZEEQR
                </Link>
              </p>
              <Link to={"hhttps://zeeqr.com/"} target="_blank">
                {" "}
                <img className="w-18" src={ftLogo} alt="" />
              </Link>
            </>
          ) : (
            <>
              <p>
                Powered by <Link> ZEEQR</Link>
              </p>
              <Link>
                {" "}
                <img className="w-18" src={ftLogo} alt="" />
              </Link>
            </>
          )}
        </div> */}
        {/* </div> */}
      </section>

      {/* {qrModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
             
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
               
                <div
                  className="popup-containerModern justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50  outline-none focus:outline-none"
                  id="modal"
                >
                  <div className="userDetails">
                    <figure>
                      {card?.profileImage ? (
                        <img src={card?.profileImage} alt="" />
                      ) : (
                        <img src={defaultProfileImage} alt="" />
                      )}
                    </figure>
                    <div className="user">
                      <h1>
                        {card?.name}
                      </h1>
                      <p>
                        {" "}
                        {card?.companyDesignatio
                        }
                      </p>
                    </div>

                    <img
                      src={card?.QRCode}
                      className="my-qr-code"
                      width="200px"
                      alt=""
                    />
                    <p className="my-qr-download" onClick={handleDownload}>
                      Download QR Code
                    </p>
                    {!showResults ? (
                      <div
                        className="addToHomeModern"
                        onClick={onClick}
                        style={{
                          background: `${Highlightcolor
                            ? Highlightcolor
                            : "linear-gradient(90deg, #FE4F32 0%, #DD2474 100%)"
                            }`,
                        }}
                      >
                        Add to Home Screen
                      </div>
                    ) : (
                      <img className="addtoHomeImageModern" src={addtoHome} alt="" />
                    )}
                  </div>

                  <button
                    className="cursor-pointer absolute top-0 left-0 mt-6 close-popup  ml-5 text-black hover:text-gray-600 transition duration-150 ease-in-out rounded focus:ring-2 focus:outline-none focus:ring-gray-600"
                    onClick={handleClose}
                    style={{
                      background: `${Highlightcolor
                        ? Highlightcolor
                        : "linear-gradient(90deg, #FE4F32 0%, #DD2474 100%)"
                        }`,
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-x"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      stroke-width="2.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null} */}
      {qrModal ? (
        <QRModal handleClose={handleClose} Iconcolor={Highlightcolor} />
      ) : null}
      {/* {preview ? (
          <>
            <span className="qr-codeClassic" onClick={() => setQrModal(true)}>
              <BsQrCodeScan size={22} />
            </span>
            <Link className="shareClassic" onClick={handleShare}>
              <img src={shareIcon} alt="" />
            </Link>
            <Link className="addToContactClassic" to={`${card?.vCard}`}>
              <img src={addIcon} alt="" />
            </Link>
          </>
        ) : (
          ""
        )} */}
    </div>
  );
}

export default ModernTheme;
